/** Two-letter initials from a display name, username, or email (matches profile avatar logic). */
export function getDisplayInitials(name: string): string {
  if (!name?.trim()) return 'U';

  const parts = name.trim().split(/[\s@._-]+/).filter((part) => part.length > 0);
  if (parts.length >= 2) {
    return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
  }
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }
  return 'U';
}
